/**
 * Obstruction Status Enum
 *
 * Lifecycle state of an obstruction. Mirrors backend
 * `GeoMarkup.Domain.Enums.ObstructionStatus` — stored as PascalCase strings.
 *
 * State machine: Planned → Scheduled → Active → (Extended →) Completed → Archived.
 */
export enum ObstructionStatus {
  /** Planned for the future, not yet scheduled. */
  Planned = 'Planned',
  /** Scheduled with confirmed dates and contractor data. */
  Scheduled = 'Scheduled',
  /** Currently active (obstruction in effect). */
  Active = 'Active',
  /** Active beyond the originally planned end date. */
  Extended = 'Extended',
  /** Completed — obstruction lifted. */
  Completed = 'Completed',
  /** Archived (manual archival after verification). */
  Archived = 'Archived',
}
